/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'

type Props = TransitionProps & {
  children: React.ReactElement<any, any>
}

function Transition(props: Props, ref: React.Ref<unknown>) {
  return <Slide direction="up" ref={ref} {...props} />
}

export default React.forwardRef(Transition)
